import { SEVERITY_STYLES } from "utils/analytics/constants";

const VARIANT_CLASSES = {
  // domain table rows use a roomier badge; error-log rows a compact one
  domain: "inline-block px-2 py-1 rounded text-sm font-medium text-center",
  compact: "inline-flex items-center px-2.5 py-0.5 rounded text-xs font-medium capitalize",
} as const;

interface SeverityBadgeProps {
  severity: string;
  variant?: keyof typeof VARIANT_CLASSES;
}

// Unknown severities render grey (default style) with their raw label rather
// than being silently mislabelled as "medium".
const SeverityBadge = ({ severity, variant = "compact" }: SeverityBadgeProps) => {
  const styleClass =
    SEVERITY_STYLES[severity?.toLowerCase() as keyof typeof SEVERITY_STYLES] ||
    SEVERITY_STYLES.default;

  return (
    <span className={`${VARIANT_CLASSES[variant]} ${styleClass}`}>
      {severity || "N/A"}
    </span>
  );
};

export default SeverityBadge;
